module.exports = __webpack_public_path__ + "static/media/IB_subjects.a6544645.png";